import { useEffect } from 'react';
import styled from 'styled-components';

import { ReferralSteps } from 'components/modals/referral/form/helpers';
import { ReferralFormMeta, ReferralFormValues } from 'components/modals/referral/SendReferralModal';
import useActivityInput from 'components/shared/activityInput/useActivityInput';
import { Form, useForm } from 'context/form';
import LocationEpisode from 'models/LocationEpisode';
import { BodySmall } from 'styles/typography';

import EditDeterminantsStep from './EditDeterminantsStep';
import ReferToStep from './ReferToStep';

type ReferralFormProps = {
  locationEpisode: LocationEpisode;
  initialPhoneNumber: string;
};

export default function ReferralForm(props: ReferralFormProps) {
  const { locationEpisode, initialPhoneNumber } = props;

  const { meta, setValue, values } = useForm<ReferralFormValues, ReferralFormMeta>();

  const { note } = useActivityInput({
    ...values.note,
    attachments: values.note?.attachments ?? [],
  });

  useEffect(() => {
    setValue('note', note);
  }, [note, setValue]);

  return (
    <>
      {meta.currentStep === ReferralSteps.ReferTo && (
        <BodySmall>
          Select a provider to send a referral in Olio. The provider can then coordinate the approval or denial of the
          referral in Olio.
        </BodySmall>
      )}
      <Form>
        <FormContainer>
          {meta.currentStep === ReferralSteps.ReferTo && <ReferToStep locationEpisode={locationEpisode} />}

          {meta.currentStep === ReferralSteps.Determinants && (
            <EditDeterminantsStep initialPhoneNumber={initialPhoneNumber} />
          )}
        </FormContainer>
      </Form>
    </>
  );
}

const FormContainer = styled.div`
  margin-top: 20px;
`;
